export default __webpack_public_path__ + "static/ICEX-6459569be1fd127f77645b8a59bf393f.png";